import BaseApiRequest from "./BaseApiRequest";
import { APPLICANT_CREATE_CONFIRM } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class ConfirmApplicantCreateRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = APPLICANT_CREATE_CONFIRM;

  constructor(reqData) {
    super();
    this.body = reqData;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
